export default __webpack_public_path__ + "static/media/business_show_5.f90239a2.png";